import React from 'react';
import { EmptyState } from '@atlassian/search-dialog';
import { injectIntl } from 'react-intl-next';
import { messages } from '../../messages';
var Image = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: "@atlaskit-internal_product-search-dialog/async-chunk/prequery-error-image" */'./error-image');
});
var PreQueryErrorScreen = function PreQueryErrorScreen(_ref) {
  var intl = _ref.intl;
  return /*#__PURE__*/React.createElement(EmptyState, {
    title: intl.formatMessage(messages.common_error_state_prequery_heading),
    Image: Image
  });
};
export default injectIntl(PreQueryErrorScreen);